import { render, staticRenderFns } from "./menu3_active_learning.vue?vue&type=template&id=f8f8fc1c&scoped=true"
import script from "./menu3_active_learning.vue?vue&type=script&lang=js"
export * from "./menu3_active_learning.vue?vue&type=script&lang=js"
import style0 from "./menu3_active_learning.vue?vue&type=style&index=0&id=f8f8fc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f8fc1c",
  null
  
)

export default component.exports